<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<section tuiContent>
	@if (loading()) {
		<tui-loader size="xl" />
	} @else if (form) {
		<form
			class="flex flex-col gap-2"
			[formGroup]="form"
			(ngSubmit)="onSubmit()"
		>
			<label tuiLabel>
				{{ 'log.log-name' | transloco }}*

				<tui-textfield tuiTextfieldSize="m">
					<input
						formControlName="name"
						tuiInput
						type="text"
						[placeholder]="'log.log-name-placeholder' | transloco"
					/>
				</tui-textfield>

				<tui-error formControlName="name" [order]="['required']" />
			</label>

			<label tuiLabel>
				{{ 'content.owner' | transloco }}*

				<tui-textfield tuiTextfieldSize="m">
					<input formControlName="createdBy" tuiInput type="text" />
				</tui-textfield>
			</label>

			<label tuiLabel>
				{{ 'log.log-entry' | transloco }}*

				<tui-textfield tuiTextfieldSize="m">
					<textarea
						tuiTextarea
						formControlName="description"
						[limit]="maxLength"
						tuiAutoFocus
					></textarea>
				</tui-textfield>

				<tui-error [order]="['']" formControlName="description" />
			</label>

			<label tuiLabel>
				{{ 'log.crops' | transloco }}*

				<tui-textfield class="hidden" tuiTextfieldSize="m" />
				<ctx-dynamic-entity-list
					[items]="cropListItems()"
					[addButtonLabel]="'action.add'"
					[emptyMessage]="'log.crops-empty' | transloco"
					(add)="onSelectCrops()"
					(remove)="onRemoveCrop($event)"
				/>

				<tui-error formControlName="crops" [order]="['required']" />
			</label>

			<div class="mt-1">
				<label class="font-size-small">
					{{ 'data.media' | transloco }}
				</label>

				<label tuiInputFiles>
					<input
						#validator="tuiInputFilesValidator"
						tuiInputFiles
						[accept]="acceptedFiles"
						formControlName="files"
						[multiple]="true"
					/>
				</label>

				<tui-files class="mt-1">
					@for (file of existingFiles(); track file) {
						@if (file.state === 'deleted') {
							<tui-file
								*tuiItem
								state="deleted"
								[file]="file"
								(remove)="onRemovedFileRestore(file)"
							>
								<small>
									{{
										'media.removing-media-item' | transloco
									}}
								</small>
							</tui-file>
						} @else {
							<tui-file
								*tuiItem
								[leftContent]="existing"
								[file]="file"
								(remove)="onExistingFileRemove(file)"
							>
								<small>
									{{
										'media.existing-media-item' | transloco
									}}
								</small>
							</tui-file>
						}
					}

					@for (
						file of form.get('files')?.valueChanges | async;
						track file
					) {
						@if (loading()) {
							<!-- Normal indicates the file was uploaded successfully -->
							<tui-file
								*tuiItem
								state="loading"
								[showDelete]="false"
								[file]="
									(file
										| tuiFileRejected: validator
										| async) || file
								"
								(remove)="onFileRemove(file)"
							>
								<small>
									{{ 'media.uploading' | transloco }}
								</small>
							</tui-file>
						} @else {
							<!-- If the file hasn't been designated a state, it's idling -->
							<tui-file
								*tuiItem
								[leftContent]="idle"
								[file]="
									(file
										| tuiFileRejected: validator
										| async) || file
								"
								(remove)="onFileRemove(file)"
							>
								<small>
									{{ 'media.waiting-for-upload' | transloco }}
								</small>
							</tui-file>
						}
					}
				</tui-files>

				<tui-error [order]="['maxLength']" formControlName="files" />
			</div>
		</form>
	}
</section>

<footer tuiFooter>
	<button tuiButton size="m" appearance="outline" (click)="onDismiss()">
		{{ 'action.cancel' | transloco }}
	</button>

	<button
		tuiButton
		size="m"
		appearance="accent"
		(click)="onSubmit()"
		[loading]="busy()"
	>
		@if (context.data.log) {
			{{ 'action.save' | transloco }}
		} @else {
			{{ 'action.create' | transloco }}
		}
	</button>
</footer>

<ng-template #idle>
	<tui-icon icon="@tui.clock" />
</ng-template>

<ng-template #existing>
	<tui-icon [style.color]="'var(--tui-status-positive)'" icon="@tui.cloud" />
</ng-template>
